import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import CalculadoraPro from "@/pages/CalculadoraPro";

export const Route = createFileRoute("/en/panel/pro-calculator")({
  head: () => ({
    meta: [
      { title: "PRO profitability calculator | Retail Lemon" },
      { name: "description", content: "Model margins, seasonality and break-even for your store." },
      { property: "og:title", content: "PRO profitability calculator | Retail Lemon" },
      { property: "og:description", content: "Margins, seasonality and break-even in one place." },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <ProtectedRoute>
      <CalculadoraPro />
    </ProtectedRoute>
  ),
});
